/**
 * Connection
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useApi2call } from 'containers/Api2/index.js';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import DeleteButton from 'components/interaction/DeleteButton/index.jsx';
import messages from '../messages.js';

function Connection(props) {
  const { conn, user, onChange, onDelete, canDelete, linkPage } = props;
  const api2call = useApi2call();
  const confirmDisconnectText = { ...messages.confirmDisconnect, values: { name: conn.accountName } };
  const link = `/admin/users/${linkPage}/${conn.id}`;
  async function handleDelete() {
    if (onDelete) {
      onDelete();
    }
    await api2call({
      method: 'DELETE',
      url: `sa/users/${user.typeName}/${user.id}/connections/${conn.id}`,
      version: 2,
      withPromise: true,
    });
    if (onChange) {
      onChange();
    }
  }
  return (
    <div className="d-flex align-items-center justify-content-between">
      <Link to={link}>
        <AvatarWithText src={conn.avatar} align="center">
          {conn.displayName}
        </AvatarWithText>
      </Link>
      {canDelete && (
        <DeleteButton
          onClick={handleDelete}
          confirmText={confirmDisconnectText}
          confirmLabel={messages.disconnect}
          className="pe-0 py-0"
        >
          <span className="d-none d-sm-inline"><FormattedMessage {...messages.disconnect} /></span>
        </DeleteButton>
      )}
    </div>
  );
}

Connection.propTypes = {
  conn: PropTypes.object,
  user: PropTypes.object,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  linkPage: PropTypes.string,
  canDelete: PropTypes.bool,
};

export default Connection;
